import { render, staticRenderFns } from "./terminalDateTips.vue?vue&type=template&id=0e7fcb0e&scoped=true"
import script from "./terminalDateTips.vue?vue&type=script&lang=js"
export * from "./terminalDateTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7fcb0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7fcb0e')) {
      api.createRecord('0e7fcb0e', component.options)
    } else {
      api.reload('0e7fcb0e', component.options)
    }
    module.hot.accept("./terminalDateTips.vue?vue&type=template&id=0e7fcb0e&scoped=true", function () {
      api.rerender('0e7fcb0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/new-column/column-h/components/terminalDateTips.vue"
export default component.exports